// @flow

import linkViewModel from '@vimcar/shared-utils/linkViewModel'

import mkViewModel from './viewModel'

const LocaleContainer = ({ children }) => children

export default linkViewModel<any, any>(mkViewModel, LocaleContainer)
